<template>
    <!-- Bandera como imagen (Windows no dibuja los emojis de bandera).
         Si la imagen no carga, queda el código ISO; sin código, un globo. -->
    <span v-if="!code" class="nf-flag nf-flag-none" aria-hidden="true">🌐</span>
    <span v-else-if="failed" class="nf-flag nf-flag-code" aria-hidden="true">{{ code.toUpperCase() }}</span>
    <img
        v-else
        class="nf-flag"
        :src="`https://flagcdn.com/w40/${lower}.png`"
        :srcset="`https://flagcdn.com/w80/${lower}.png 2x`"
        width="22"
        height="16"
        alt=""
        loading="lazy"
        @error="failed = true"
    >
</template>

<script>
export default {
    name: 'NfFlag',
    props: {
        code: { type: String, default: '' },
    },
    data() {
        return { failed: false }
    },
    computed: {
        lower() { return this.code.toLowerCase() },
    },
    watch: {
        code() { this.failed = false },
    },
}
</script>

<!-- Estilos del combobox y la bandera (globales, prefijo nf-): sirven fuera de /formulario. -->
<style src="./nfCombo.css"></style>
